import { apiRequest } from "./common";

const getMentorList = async (pageNo, pagesize, filters, searchText, isMentor) => {
    const response = await apiRequest('get', `/mentor?page=${pageNo}&limit=${pagesize}&meetingLink=${isMentor}${filters ? `&filters=${filters}` : ''}${searchText ? `&search=${searchText}` : ''}`);
    return response.data;
};

const blockingMentor = async (id) => {
    const response = await apiRequest('patch', `/mentor/${id}/block`);
    return response.data;
};

const unBlockingMentor = async (id) => {
    const response = await apiRequest('patch', `/mentor/${id}/unblock`);
    return response.data;
};

const deleteMentor = async (id) => {
    const response = await apiRequest('delete', `/mentor/${id}`);
    return response.data;
}

const updateMentorData = async (id, data) => {
    const response = await apiRequest('put', `/mentor/${id}`, data);
    return response.data;
};

const inviteMentor = async (data) => {
    const response = await apiRequest('post', `/mentor/invite`, data);
    return response.data;
};

const resendInvitation = async (id) => {
    const response = await apiRequest('post', `/mentor/${id}/resend-invitation`);
    return response.data;
};

const getMentor = async (id) => {
    const response = await apiRequest('get', `/mentor/${id}`);
    return response.data;
};

const generateMeetingLink = async () => {
    const response = await apiRequest('get', `/mentor/generate-session-link`);
    return response.data;
};

const getMentorStudent = async (pageNo, pageSize, filters, searchText) => {
    const response = await apiRequest('get', `/mentor/students?page=${pageNo}&limit=${pageSize}&filters=${filters}&search=${searchText}`);
    return response.data;
};

const getMentorByEventId = async (eventId) => {
    const response = await apiRequest('get', `/mentor/by-event/${eventId}`);
    return response.data;
};

const mentorsByStudent = async (studentId) => {
    const response = await apiRequest('get', `/mentor/by-student/${studentId}`);
    return response.data;
};

const getInsights = async (studentId, mentorId) => {
    const response = await apiRequest('get', `/mentor/by-student-mentor/${studentId}/${mentorId}`);
    return response.data;
};

const updateInsight = async (mentorId, data) => {
    const response = await apiRequest('patch', `/mentor/${mentorId}/update`, data);
    return response.data;
};

const getCounsellorDashboard = async (studentId) => {
    const response = await apiRequest('get', `/mentor/counselor-dashboard?studentId=${studentId}`);
    return response.data;
};

const inviteCounsellor = async (data) => {
    const response = await apiRequest('post', `/mentor/invite-counselor`, data);
    return response.data;
};

const acceptInvitation = async (data) => {
     const response = await apiRequest('post', `/mentor/update-invite-status`, data);
    return response.data;
};

const updateMentorAvailability = async (id, data) => {
     const response = await apiRequest('patch', `/mentor/${id}/availability`, data);
    return response.data;
};

export {
    getMentorList,
    blockingMentor,
    unBlockingMentor,
    updateMentorData,
    inviteMentor,
    resendInvitation,
    getMentor,
    generateMeetingLink,
    getMentorStudent,
    getMentorByEventId,
    mentorsByStudent,
    getInsights,
    updateInsight,
    getCounsellorDashboard,
    inviteCounsellor,
    acceptInvitation,
    updateMentorAvailability,
    deleteMentor
}